/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var WG_SOCIAL_FE = {
    // All pages
    'common': {
      init: function() {

        // JavaScript to be fired on all pages
        function popupwindow(uri, name, w, h) {
          var y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
          var x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);

          var win = window.open(uri, name, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+y+', left='+x );
          var interval = window.setInterval(function() {
              try {
                  if (win == null || win.closed) {
                    window.clearInterval(interval);
                  }
              }
              catch (e) {
              }
          }, 1000);
          return win;
        }

        $(document).on('click','.wg-social-share-front-end-buttons a',function(e){
          e.preventDefault();
            var width = 600;
            var height = 500;
            var type = $(this).attr('data-type');
            if ( type === 'linkedin' ) {
              width = 1000;
              height = 700;
            }
            popupwindow( $(this).attr('href'), $(this).attr('title'), width, height );
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var WG_SOCIAL_UTIL_FE = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = WG_SOCIAL_FE;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      WG_SOCIAL_UTIL_FE.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        WG_SOCIAL_UTIL_FE.fire(classnm);
        WG_SOCIAL_UTIL_FE.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      WG_SOCIAL_UTIL_FE.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(WG_SOCIAL_UTIL_FE.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
